module.exports = __webpack_public_path__ + "static/media/theMofG11.eb1a6ece.png";